import React, { useEffect } from 'react';

export function useEditStepModal(isOpen, stepNumber) {

  useEffect(() => {
    const onModalShow = () => {
      const first = document.getElementById('step_number');
      const fristValue = first?.getBoundingClientRect();
      if (isOpen && fristValue?.height) {
        first.value = stepNumber;
      }
    };
    onModalShow();
    window.addEventListener('DOMContentLoaded', onModalShow);
    return () => {
      window.removeEventListener('DOMContentLoaded', onModalShow);
    };
  });
}